export default (props, vars) => `Step ${props?.['step'] || 1}/8`;
